import React, { useState } from "react";
import Modal from "react-modal";
import AddPostsUI from "./add-posts-ui";
import AddTestimonialUI from "./add-testimonial-ui";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    background: "transparent",
  },
  overlay: {
    zIndex: 100,
    // backgroundColor: "#1E2A42",
  },
};

const AddTestimonial = ({
  modalIsOpen,
  afterOpenModal,
  closeModal,
  payload,
  loginUser,
  setTestimonials,
  setAllTestimonials,
}) => {
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Add Post">
        <AddTestimonialUI
          closeModal={closeModal}
          payload={payload}
          loginUser={loginUser}
          setTestimonials={setTestimonials}
          setAllTestimonials={setAllTestimonials}
        />
      </Modal>
    </div>
  );
};

export default AddTestimonial;
